// native
import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';

// service
import { BaseFilterCellComponent, GridFilterService } from '../grid-filter.service';

// models
import { FilterOperator } from 'app/models';

const OPERATOR_LABELS: Record<string, string> = {
  gte: 'Is after or equal to',
  lte: 'Is before or equal to'
};

/** Date filter cell: mat-datepicker input + operator chooser + clear button. */
@Component({
    selector: 'app-grid-date-filter',
    templateUrl: './grid-date-filter.component.html',
    standalone: false
})
export class GridDateFilterComponent extends BaseFilterCellComponent implements OnInit {
  @Input() column: { field: string; };
  @Input() operators: FilterOperator[] = ['gte', 'lte'];

  /** moment | Date — passed straight to the service, which handles both. */
  value: unknown = null;
  selectedOperator: FilterOperator;
  menuOpen = false;

  constructor(filterService: GridFilterService, private host: ElementRef) {
    super(filterService);
  }

  ngOnInit(): void {
    const existing = this.filterByField(this.column.field);
    this.value = existing?.value ?? null;
    this.selectedOperator = (existing?.operator as FilterOperator) ?? this.operators[0];
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  selectOperator(op: FilterOperator): void {
    this.selectedOperator = op;
    this.menuOpen = false;
    if (this.value != null) {
      this.apply();
    }
  }

  clear(): void {
    this.value = null;
    this.apply();
  }

  apply(): void {
    this.applyFilter(
      this.value == null
        ? this.removeFilter(this.column.field)
        : this.updateFilter({ field: this.column.field, operator: this.selectedOperator, value: this.value })
    );
  }

  label(op: string): string {
    return OPERATOR_LABELS[op] ?? op;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.menuOpen && !this.host.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
  }
}
